module.exports = __webpack_public_path__ + "img/product-chaintimingkit-modal.993d9b6b.png";